import styled from "styled-components";

export const Spinner = styled.div`
  position: absolute;
  top: 2%;
  right: 5%;
  font-size: 12px;
`;
